import { render, staticRenderFns } from "./JobPresent.vue?vue&type=template&id=8a00851c&scoped=true&"
import script from "./JobPresent.vue?vue&type=script&lang=js&"
export * from "./JobPresent.vue?vue&type=script&lang=js&"
import style0 from "./JobPresent.vue?vue&type=style&index=0&id=8a00851c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a00851c",
  null
  
)

export default component.exports